import React from "react"
import styled, { keyframes } from "styled-components"
import { FaWhatsapp } from "react-icons/fa"

const WhatsAppButton = () => (
  <Wrapper>
    <Tooltip>
      <span>¿Necesitas ayuda?</span>
      <span>Escríbenos</span>
      <Arrow />
    </Tooltip>
    <FloatingLink
      href="https://api.whatsapp.com/send?phone=51945440268&text=Hola%20INTRAMET:%20Deseo%20ponerme%20en%20contacto%20con%20un%20representante."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <FaWhatsapp />
    </FloatingLink>
  </Wrapper>
)

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`

const Wrapper = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 8;
  display: flex;
  align-items: center;

  &:hover > div:first-child {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
  }

  @media (max-width: 768px) {
    bottom: 1.5rem;
    right: 1.5rem;
  }
`

const Tooltip = styled.div`
  background-color: #fff;
  color: #002856;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.3;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  transition: 0.3s;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: 13px;

  span:last-of-type {
    font-weight: 400;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    opacity: 0;
    visibility: hidden;
    transform: translateX(10px);
  }
`

const Arrow = styled.div`
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #fff;
`

const FloatingLink = styled.a`
  background-color: #25d366;
  color: #fff;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s, box-shadow 0.3s;
  animation: ${pulse} 2s infinite;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    animation: none;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 1.6rem;
  }
`

export default WhatsAppButton
